import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

// Componente base para todos los tipos de mensajes
const MessageBase = ({ sender, timestamp, status, children }) => {
    const isUser = sender === 'user';

    // Formatear la hora
    let hours = timestamp.getHours();
    const minutes = timestamp.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // El 0 debe ser tratado como 12
    const formattedTime = `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;

    // Determinamos qué ícono mostrar según el estado
    const renderStatus = () => {
        switch (status) {
            case 'sending':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <AccessTimeIcon sx={{ fontSize: '16px', color: '#888' }} />
                    </Box>
                );

            case 'failed':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <ErrorOutlineIcon sx={{ fontSize: '16px', color: 'red' }} />
                    </Box>
                );
            case 'delivered':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CheckIcon sx={{ fontSize: '16px', color: '#888' }} />
                        <CheckIcon sx={{ fontSize: '16px', color: '#888' }} />
                    </Box>
                );
            case 'read':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CheckIcon sx={{ fontSize: '16px', color: '#0385ff' }} />
                        <CheckIcon sx={{ fontSize: '16px', color: '#0385ff' }} />
                    </Box>
                );
            case 'sent':
            default:
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CheckIcon sx={{ fontSize: '16px', color: '#888' }} />
                    </Box>
                );
        }
    };

    return (
        <Box
            sx={{
                alignSelf: isUser ? 'flex-end' : 'flex-start',
                maxWidth: '70%',
                minWidth: '40%',
                backgroundColor: isUser ? '#064b3e' : '#ffffff',
                color: isUser ? 'white' : 'black',
                padding: '10px 10px',
                borderRadius: '20px',
                marginBottom: 1,
                boxShadow: 8,
                position: 'relative',
                wordBreak: 'break-word',
            }}
        >
            {/* Contenido del mensaje (pasado como children) */}
            {children}

            {/* Hora y palomitas */}
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    right: 10,
                    display: 'flex',
                    gap: '5px',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    paddingBottom: '5px',
                }}
            >
                {/* Hora */}
                <Typography
                    variant="body2"
                    sx={{
                        color: '#888',
                        fontSize: '0.8rem',
                    }}
                >
                    {formattedTime}
                </Typography>

                {/* Palomitas (solo para mensajes enviados por el usuario) */}
                {isUser ? renderStatus() : ""}
            </Box>

            {/* Burbuja de mensaje tipo "WhatsApp" */}
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    right: isUser ? '5px' : 'auto',
                    left: !isUser ? '5px' : 'auto',
                    width: '0',
                    height: '0',
                    borderLeft: isUser ? '10px solid #064b3e' : '10px solid #ffffff',
                    borderTop: '10px solid transparent',
                }}
            />
        </Box>
    );
};

export default MessageBase;